import * as Yup from 'yup';
import { subYears } from 'date-fns';
import { contractSignerSchema } from '../../userFormValidations';
import { MIN_USER_AGE } from '../../../constants';
import { ROAD_CARE_MAX_AGE } from '../../../constants/roadCare';

export const calculatorSchema = Yup.object({
  releaseYear: Yup.object().required('validationErrors.isRequired'),
  transportUseType: Yup.object().required('validationErrors.isRequired'),
});

export const searchVehicleSchema = Yup.object().shape({
  plateNumber: Yup.string().required('validationErrors.isRequired'),
  passport: Yup.string().required('validationErrors.isRequired'),
  hasAgreed: Yup.boolean().oneOf([true]),
});

export const roadCareContractSignerSchema = contractSignerSchema.shape({
  birthday: Yup.date()
    .max(subYears(new Date(), MIN_USER_AGE), 'validationErrors.minAge')
    .min(subYears(new Date(), ROAD_CARE_MAX_AGE), 'validationErrors.maxAge')
    .typeError('validationErrors.invalidDate')
    .nullable()
    .required('validationErrors.isRequired'),
});

export const roadCareCalculationAgreement = Yup.object().shape({
  hasAgreed: Yup.boolean().oneOf([true]),
});
